module.exports = __webpack_public_path__ + "img/monitoring-ship-green.964bda8c.svg";